import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Radium, { Style } from 'radium';
import { connect } from 'react-redux';

import * as selectors from '../App/selectors';

import globalRTLStyles from './globalRTLStyles';
import conversationRTLStyles from './conversationRTLStyles';
import historyRTLStyles from './historyRTLStyles';
import campaignRTLStyles from './campaignRTLStyles';

class AppStylesRTL extends PureComponent {
  renderCustomOverride() {
    const styles = Object.assign({}, globalRTLStyles, conversationRTLStyles, historyRTLStyles, campaignRTLStyles);
    return <Style scopeSelector=".kustomer[dir='rtl']" rules={styles} />;
  }

  renderBodyOverride() {
    const styles = Object.assign({}, globalRTLStyles, conversationRTLStyles, historyRTLStyles, campaignRTLStyles);
    return <Style scopeSelector="body[dir='rtl']" rules={styles} />;
  }

  render() {
    const { rtlOverride } = this.props;
    return rtlOverride ? this.renderCustomOverride() : this.renderBodyOverride();
  }
}

AppStylesRTL.propTypes = {
  rtlOverride: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    rtlOverride: selectors.getAppIsRTL(state),
  };
};

export default connect(mapStateToProps)(Radium(AppStylesRTL));
